/**
 * Конвертация числа с плавающей точкой в строку фикс числом знаков.
 *
 * Незначащие нули удаляются.
 *
 * @param {number} num Число
 * @param {int} fixed Число знаков после запятой
 * @returns
 */
export function num2str(num, fixed = 2) {
  return num.toFixed(fixed).replace(/\.0+$/, '')
}
